import { SEARCH_CHANGED, STATUS_CHANGED } from "./actionTypes";
import { initialState } from "./initialState";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case STATUS_CHANGED:
      return { ...state, status: action.payload };

    case SEARCH_CHANGED:
      return { ...state, search: action.payload };

    default:
      return state;
  }
};

export default reducer;
